export default "__VITE_ASSET__CCSTsHue__"